import { apiCall } from "../helpers/api";

export const messages = (params = {}) => dispatch => {
    params.path = params.path || "messages";
    // params.method = params.method || "GET";

    return dispatch(apiCall(params));
}